/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".slider[_ngcontent-%COMP%]{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex}.slider__range[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1 1 100%}.slider__input[_ngcontent-%COMP%]{-webkit-box-flex:0;flex:0 0 64px;margin-left:8px}"];
export { styles as styles };
